export default function Title({ text }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
      <h1 className="text-2xl font-semibold text-neutral-900">{text}</h1>
    </div>
  );
}
